import React from 'react'

export default props => (
  <svg width="14" height="19" viewBox="0 0 14 19" fill="none" {...props}>
    <path
      stroke="#00112B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 9.05263V12.1842C7 13.9111 8.34571 15.3158 10 15.3158C11.6543 15.3158 13 13.9111 13 12.1842V7.26316C13 3.80053 10.3171 1 7 1C3.68286 1 1 3.80053 1 7.26316V12.6316C1 15.5932 3.30571 18 6.14286 18"
    />
  </svg>
)
